// @flow @jsx h
/* eslint-disable promise/catch-or-return */
/* eslint-disable promise/always-return */
import { Component, h } from 'preact'
// import { bem, toArray } from '@nrk/dh-utils'
// import { ViewportIntersections, SerumLazyResponsivePicture } from '@nrk/dh-feature-components'

import styles from './index.css'

import type { SimpleGalleryType } from '../../domain'
import { HtmlContent } from '@nrk/dh-feature-components'
import Scrollchor from 'preact-scrollchor'

type Props = {
  groups: SimpleGalleryType[],
  arrowText: string,
  overskrift: string,
  nextChapter: string,
  shortcut: string,
  load: boolean
}

type State = {
  loadContent: boolean[],
}

export class SimpleGallery extends Component<Props, State> {
  // looping = false
  elm: any
  sweetScroll: any

  constructor () {
    super()
    this.state = {
      loadContent: []
    }
  }

  componentDidMount () {
    window.addEventListener('resize', this.updateSizes)
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.updateSizes)
  }

  render () {
    const { groups, arrowText, overskrift, nextChapter, shortcut } = this.props
    return (

      <div class={styles.gallery}>
        {shortcut &&
          <span id={shortcut}>&nbsp;</span>
        }
        <h2><span class={styles.overskrift}>{overskrift}</span></h2>
        {arrowText &&
          <div class={styles.gallery__scrollon}>
            <div class={styles.animated}>
              <span class={styles.gallery__arrowdown}>&nbsp;</span>
            </div>
            <span class={styles.gallery__scrollText}><Scrollchor to={nextChapter}>{arrowText}</Scrollchor></span>
          </div>
        }
        <div>
          <ul class={styles.gallery__list}>
            {
              groups.map((image, idx) => (
                <li class={styles.gallery__listItem} key={idx}>
                  <div class={styles.gallery__person}>
                    <figure className={styles.person__figure} data-name={image.navn}>
                      <img src={`https://nrk.no/serum/api/imagecrop/${image.polopolyId ? image.polopolyId : 1.14492856}?cropid=f${image.ratio}w420`} alt={`Bilde av ${image.navn}`} />
                      {image.imageText && (
                        <span className={styles.person__figureImageText}>{image.imageText}</span>
                      ) }
                    </figure>
                    <h4 class={styles.gallery__name}>{image.navn}</h4>
                    <div class={styles.person__header}>
                      <div class={styles.person__meta}>
                    F&oslash;dt: {image.born}
                      </div>
                    </div>
                    <div class={styles.gallery__text}>
                      <HtmlContent content={image.text} type={'div'} />
                    </div>
                  </div>
                </li>
              ))
            }
          </ul>
        </div>
        <span id={nextChapter}>&nbsp;</span>
      </div>

    )
  }
}

/*
<figure>
                  <SerumLazyResponsivePicture
                    className={styles.imageGallery__image}
                    id={image.polopolyId}
                    alt={image.alt}
                    sizes={'(min-width: 720px) 472px, 85vw'}
                    ratio={image.ratio}
                    quality={0.8}
                    load={this.props.load && this.state.loadContent[idx]} />
                  <figcaption>
                    {image.caption}
                  </figcaption>
                </figure>
                */

/*
<div class={styles.imageGallery__container}>
        <ViewportIntersections
          className={styles.imageGallery}
          root={'self'}
          threshold={[0, 0.05, 0.5, 0.95, 1]}>
          <div class={styles.imageGallery__spacerLeft} />
          {
            groups.map((image, idx) => (
              <div
                key={idx}
                class={bem(styles.imageGallery__imageWrapper, {
                  vertical: VERTICAL_ASPECTS.indexOf(image.ratio) !== -1,
                  visible: !!visibleContent[idx]
                })}>
                <span>
                  {image.navn}
                </span>

              </div>))
          }

          <div
            className={styles.imageGallery__spacerRight} />
        </ViewportIntersections>
      </div>
*/
